import React, {FC} from 'react';

import AnimateHeight from 'react-animate-height';

import {STEPS} from '../../constants/checkout';

import s from './stepBody.scss';

type PropsType = {
    step: STEPS;
    currentStep: string;
    children: React.ReactNode;
};

const STEP_BODY_ANIMATION_DURATION = 1000;

/**
 * Step body component
 * @constructor
 */
export const StepBody: FC<PropsType> = ({children, currentStep, step}) => {
    const isCurrentStepActive = step === currentStep;

    return (
        <AnimateHeight
            className={s.body}
            duration={STEP_BODY_ANIMATION_DURATION}
            height={isCurrentStepActive ? 'auto' : 0}
        >
            {children}
        </AnimateHeight>
    );
};
